import React, { Component } from 'react';
import SectionHeader from './../component/section-header';
import Accordion1 from './../component/accordion';

// header section content
const title = <h3 className="mb--20">Preguntas frecuentes</h3>;
const subtitle = <h6>Aquí podrás encontrar las preguntan más frecuentes de nuestros clientes y usuarios.</h6>;
const alignment = 'section-header text-center pb--40';

class FaqSection extends Component {
    
    render() {
        return (
            <section id="faq" className="axsis-faq-section pt--50 pb--50">
                <div className="container p-0">
                    <div className="container-sm">
                        <SectionHeader 
                            title={ title } 
                            subtitle={ subtitle }
                            alignment={alignment}
                        />

                        <div className="faq-container">
                            <Accordion1 />
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default FaqSection;